// FilterList
import React from 'react';
import PropTypes from 'prop-types';
import { getUrlSafeHash } from '../../utils/url-utils';

const FilterSelectionListItem = ({ filterClick, option }) => {
  const id = getUrlSafeHash(option.name);
  const isColorOption = option.inputName.indexOf('color-option') !== -1;
  return (
    <li role="menuitem" key={id} className={`filter--option ${(option.isHidden) ? 'hidden' : ''}`}>
      <input id={id} name={option.inputName} type={option.type} value={option.value} onChange={() => filterClick(option)} checked={(option.isChecked === true ? 'checked' : '')} />
      <label className="checkbox--label" htmlFor={id}>
        {isColorOption
            && (
              <div className={`filter--color-option ${id}`} />
            )
          }
        {option.name}
      </label>
    </li>
  );
};

FilterSelectionListItem.propTypes = {
  filterClick: PropTypes.func.isRequired,
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    inputName: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    isHidden: PropTypes.bool.isRequired,
    isChecked: PropTypes.bool.isRequired,
  }),
};

const FilterSelectionList = props => (
  <fieldset id={`${getUrlSafeHash(props.filter.name)}-selection-list`}>
    <legend className="sr-only">Filter by {props.filter.name}</legend>
    <ul role="menu">
      {props.filter.options.map(option => (
        <FilterSelectionListItem key={getUrlSafeHash(option.name)} {...Object.assign({}, props, { option })} />
      ))}
      <li role="presentation">
        <button
          className={`show-more-btn link btn-transparent ${(!props.filter.showMore) ? 'hidden' : ''}`}
          type="button"
          onClick={event => props.showAllFilterItems(event, props.filter.name)}
          aria-label={`Show more ${props.filter.name}s`}
          role="menuitem"
        >
          Show more {props.filter.name}s ({props.filter.options.length})
        </button>
      </li>
    </ul>
  </fieldset>
);

FilterSelectionList.propTypes = {
  showAllFilterItems: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    name: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    showMore: PropTypes.bool.isRequired,
    options: PropTypes.arrayOf(PropTypes.object),
  }),
  option: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
};

const FilterSetListItem = props => (
  <div className={`filter filter-set ${(props.filter.active === true ? 'is-active' : '')}`}>
    <button
      type="button"
      className="filter--heading btn btn-white rounded-0"
      aria-expanded={props.filter.active}
      aria-controls={`${getUrlSafeHash(props.filter.name)}-selection-list`}
      onClick={event => props.buttonClick(event, props.filter.name)}
    >
      <span className="icon" />
      {props.filter.name}
    </button>
    <FilterSelectionList {...props} />
  </div>
);

FilterSetListItem.propTypes = {
  buttonClick: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    name: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
  }),
};

const FilterSetList = props => (
  <div>
    {Object.keys(props.filters).filter(key => typeof props.filters[key] !== 'string').sort((keyA, keyB) => props.filters[keyA].order - props.filters[keyB].order).map(key => (
      <FilterSetListItem key={key} order={props.filters[key].order} {...props} filter={props.filters[key]} />
    ))}
  </div>
);

FilterSetList.propTypes = {
  filters: PropTypes.shape(PropTypes.object),
  filter: PropTypes.shape({
    order: PropTypes.number.isRequired,
  }),
};

export {
  FilterSetList,
  FilterSetListItem,
  FilterSelectionList,
  FilterSelectionListItem,
};
